import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { InvoicingModelEnums } from 'src/app/enum/invoicing-model-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoicingModelModel } from '../../../../models/invoicing/invoicing-model.model';
import { InvoicingModelService } from 'src/app/services/invoicing/invoicing-model.service';
import { ConceptInvoicingTypeEnums } from 'src/app/enum/concept-invoicing-enums';

@Component({
  selector: 'app-register-invoicing-model',
  templateUrl: './register-invoicing-model.component.html',
  styleUrls: ['./register-invoicing-model.component.scss'],
  standalone: false
})
export class RegisterInvoicingModelComponent implements OnInit, OnDestroy {

  conceptInvoicingType: number = 1;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  formInvoicingModel: FormGroup = new FormGroup({});
  invoicingModelContract: InvoicingModelModel = new InvoicingModelModel();
  invoicingModelId: number = 0;
  isOpened: string | undefined = undefined;
  labelModel: string = 'Prueba de componente';
  nameWindow: string = 'Captura Modelos de Facturación';
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  updateListDetail: boolean = false;
  url: string = 'invoicing-model';
  userAuthenticated: UserModel = new UserModel();

  constructor(private confirmDialogService: ConfirmDialogService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private invoicingModelService: InvoicingModelService,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.invoicingModelContract);
  }

  async ngOnInit() {
    await this.getPermission();
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.invoicingModelId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeConsecutive() {
    let consecutive = this.formInvoicingModel.get("consecutive")?.value;

    if (consecutive < 0 || consecutive === null || consecutive.toString().trim() === "") consecutive = 0;

    if (consecutive === 0) {
      this.createInvoicingModel();
    } else {
      try {
        if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
          this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getPurchaseModelByConsecutive(consecutive));
        } else {
          this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getInvoicingModelByConsecutive(consecutive));
        }
        this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
        this.validateForm(this.invoicingModelContract);
        this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
      } catch (error) {
        console.error("Error al obtener el modelo por consecutivo:", error);
        this.createInvoicingModel();
      }
    }
  }

  createInvoicingModel() {
    this.invoicingModelContract = new InvoicingModelModel();
    this.invoicingModelContract.consecutive = 0;
    this.invoicingModelId = 0;
    this.validateForm(this.invoicingModelContract);
    this.disabledDetail = true;
    this.quantityDetails = 0;
    setTimeout(() => this.formInvoicingModel.controls["consecutive"].disable(), 100);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteInvoicingModel() {
    const nameEntity = this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra ? 'compra' : 'facturación';
    if (this.invoicingModelContract.invoicingModelId != 0 && this.invoicingModelContract.invoicingModelId != null) {
      if (this.permissionUpdatable) {
        if (this.invoicingModelContract.consecutive === InvoicingModelEnums.base) {
          this.toastHandlerService.showToast(
            'warning',
            `El modelo base de ${nameEntity} no se puede eliminar.`
          );
          return;
        }

        if (this.quantityDetails > 0) {
          this.toastHandlerService.showToast(
            'warning',
            `No se puede eliminar el modelo de ${nameEntity} mientras tenga detalle.`
          );
          return;
        }

        if (await this.confirmDialogService.confirm(`¿Realmente desea eliminar el modelo de ${nameEntity} actual?`)) {
          try {
            if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
              await firstValueFrom(this.invoicingModelService.deletePurchaseModel(this.invoicingModelId));
            } else {
              await firstValueFrom(this.invoicingModelService.deleteInvoicingModel(this.invoicingModelId));
            }
            this.createInvoicingModel();
            this.toastHandlerService.showToast(
              'success',
              `El modelo de ${nameEntity} fue eliminado exitosamente.`
            );
          } catch (error) {
            console.error(`Error al eliminar el modelo de ${nameEntity}: `, error);
          }
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          `El usuario no tiene permisos para eliminar modelos de ${nameEntity}. Comuníquese con el administrador del sistema.`
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear un modelo de ${nameEntity}.`
      );
      return;
    }
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formInvoicingModel.get("consecutive")?.value;

    if (consecutive < 0 || consecutive == "" || consecutive == null) consecutive = 0;

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getFirstPurchaseModelByKeysAsync());
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getFirstInvoicingModelByKeysAsync());
          }
          this.validateForm(this.invoicingModelContract);
          this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
          this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
        } catch (error) {
          console.error('Error al obtener el primer modelo por claves:', error);
        }
        break;
      }
      case 'previus': {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getPreviusPurchaseModelByKeysAsync(consecutive));
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getPreviusInvoicingModelByKeysAsync(consecutive));
          }
          this.validateForm(this.invoicingModelContract);
          this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
          this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
        } catch (error) {
          console.error('Error al obtener el modelo anterior por claves:', error);
        }
        break;
      }
      case 'next': {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getNextPurchaseModelByKeysAsync(consecutive));
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getNextInvoicingModelByKeysAsync(consecutive));
          }
          this.validateForm(this.invoicingModelContract);
          this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
          this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
        } catch (error) {
          console.error('Error al obtener el modelo siguiente por claves:', error);
        }
        break;
      }
      case 'last': {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getLastPurchaseModelByKeysAsync());
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getLastInvoicingModelByKeysAsync());
          }
          this.validateForm(this.invoicingModelContract);
          this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
          this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
        } catch (error) {
          console.error('Error al obtener el último modelo por claves:', error);
        }
        break;
      }
    }
  }

  async getInvoicingModelById() {
    try {
      if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
        this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getPurchaseModelById(this.invoicingModelId));
      } else {
        this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.getInvoicingModelById(this.invoicingModelId));
      }
      this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
      this.validateForm(this.invoicingModelContract);
    } catch (error) {
      console.error('Error al obtener el Modelo por ID.', error);
    }
  }

  async getPermission() {
    const url = this.router.url as string;
    if (url && url !== '/') {
      const parts = url.split('/');
      this.url = parts[1];
    }

    this.conceptInvoicingType = this.url === 'purchase-model' ? ConceptInvoicingTypeEnums.compra : ConceptInvoicingTypeEnums.venta;
    this.nameWindow = this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra ? 'Captura Modelos de Compra' : 'Captura Modelos de Facturación';

    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InvoicingModel));
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
  }

  getUpdateListDetail() {
    this.updateListDetail = !this.updateListDetail;
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/${this.url}`]);
  }

  async handleInitialState() {
    if (this.invoicingModelId !== null && this.invoicingModelId !== 0) {
      await this.getInvoicingModelById();
    } else {
      this.createInvoicingModel();
    }
  }

  async send() {
    Object.keys(this.formInvoicingModel.controls).forEach(key => {
      const control = this.formInvoicingModel.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingModel.valid) {
      const modelInvoicingModel = this.formInvoicingModel.getRawValue() as InvoicingModelModel;
      const nameEntity = this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra ? 'compra' : 'facturación';

      if (this.invoicingModelId === 0) {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.createPurchaseModel(modelInvoicingModel));
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.createInvoicingModel(modelInvoicingModel));
          }
          this.invoicingModelId = this.invoicingModelContract.invoicingModelId;
          this.validateForm(this.invoicingModelContract);
          this.location.replaceState(`/${this.url}/register/${this.invoicingModelId}`);
          this.toastHandlerService.showToast(
            'success',
            `El modelo de ${nameEntity} fue creado exitosamente.`
          );
        } catch (error) {
          console.error(`Error al crear el modelo de ${nameEntity}.`, error);
        }
      } else {
        this.invoicingModelContract.description = modelInvoicingModel.description;
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.updatePurchaseModel(this.invoicingModelContract));
          } else {
            this.invoicingModelContract = await firstValueFrom(this.invoicingModelService.updateInvoicingModel(this.invoicingModelContract));
          }
          this.validateForm(this.invoicingModelContract);
          this.toastHandlerService.showToast(
            'success',
            `El modelo de ${nameEntity} fue modificado exitosamente.`
          );
        } catch (error) {
          console.error(`Error al actualizar el modelo de ${nameEntity}.`, error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      consecutive: {
        required: 'El campo Modelo es obligatorio.',
        min: 'Debe ingresar un Modelo válido.'
      },
      description: {
        required: 'El campo Descripción es obligatorio.',
        maxlength: 'La descripción no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingModel.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState() {
    if (this.permissionUpdatable) {
      this.disabledDetail = false;
      this.disabledForm = false;
      setTimeout(() => this.formInvoicingModel.enable(), 100);
    } else {
      this.disabledForm = true;
      this.disabledDetail = true;
      setTimeout(() => this.formInvoicingModel.disable(), 100);
      setTimeout(() => this.formInvoicingModel.controls["consecutive"].enable(), 100);
    }
  }

  validateForm(invoicingModel: InvoicingModelModel) {
    this.formInvoicingModel = this.formBuilder.group({
      consecutive: [invoicingModel.consecutive, [Validators.required, Validators.min(0)]],
      description: [invoicingModel.description, [Validators.required, Validators.maxLength(250)]]
    });
    if (invoicingModel.consecutive === InvoicingModelEnums.base) {
      this.labelModel = 'MODELO BASE';
    } else {
      this.labelModel = 'MODELO SECUNDARIO';
    }
    this.updateFormState();
  }

}
